import React from 'react';
import Appearance from 'styles/Appearance.js';
import Button from 'views/Button.js';
import Utils from 'files/Utils.js';

const FeaturedProduct = ({ product, reversed, onExplore, onViewDetails, background }) => {

    if(!product) {
        return null;
    }

    const contentSection = (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        }}>
            {/* Decorative brand name */}
            <span style={{
                fontFamily: Appearance.fonts.heading,
                fontWeight: 700,
                fontSize: 14,
                color: Appearance.colors.primary(),
                opacity: 0.5,
                marginBottom: 12,
                fontStyle: 'italic',
            }}>
                {'Aqua Link'}
            </span>

            <h3 style={{
                ...Appearance.textStyles.heading(),
                marginBottom: 16,
            }}>
                {product.title}
            </h3>

            <p style={{
                ...Appearance.textStyles.body(),
                marginBottom: 24,
                maxWidth: 460,
            }}>
                {product.description}
            </p>

            {/* Feature list */}
            {product.features && (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                    marginBottom: 28,
                }}>
                    {product.features.slice(0, 3).map((feature, index) => (
                        <div key={index} style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                        }}>
                            <div style={{
                                width: 6,
                                height: 6,
                                borderRadius: 3,
                                backgroundColor: product.color || Appearance.colors.primary(),
                                flexShrink: 0,
                            }} />
                            <span style={Appearance.textStyles.body({ fontSize: 14, color: Appearance.colors.text() })}>
                                {feature}
                            </span>
                        </div>
                    ))}
                </div>
            )}

            <div style={{ display: 'flex', alignItems: 'center', gap: 24, flexWrap: 'wrap' }}>
                <Button
                    label={'Add To Cart'}
                    type={'primary'}
                    onClick={() => onExplore && onExplore(product)} />
                <span
                    onClick={() => onViewDetails && onViewDetails(product)}
                    style={{
                        color: Appearance.colors.primary(),
                        fontFamily: Appearance.fonts.body,
                        fontSize: 16,
                        fontWeight: 500,
                        cursor: 'pointer',
                    }}>
                    {'Learn more ›'}
                </span>
            </div>
        </div>
    );

    // Clean rounded product stage — the image fills it edge-to-edge (cover),
    // so studio photos never float as a hard-edged rectangle. Stage tone is the
    // opposite of the section background for contrast.
    const stageBackground = background === Appearance.colors.offWhite
        ? Appearance.colors.white
        : Appearance.colors.offWhite;

    const imageSection = (
        <div style={{
            width: '100%',
            borderRadius: 28,
            overflow: 'hidden',
            backgroundColor: stageBackground,
            height: Utils.isMobile() ? 300 : 460,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            {product.images && product.images.length > 0 ? (
                <img
                    src={product.images[0].src}
                    alt={product.title}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
                <i className={product.icon || 'fas fa-box'} style={{
                    fontSize: Utils.isMobile() ? 60 : 90,
                    color: Appearance.colors.lightGrey,
                }} />
            )}
        </div>
    );

    return (
        <section style={{
            backgroundColor: background || Appearance.colors.white,
            width: '100%',
        }}>
            <div style={{
                maxWidth: Appearance.layout.maxWidth,
                margin: '0 auto',
                padding: Appearance.layout.sectionPadding(),
                display: 'grid',
                gridTemplateColumns: Utils.isMobile() ? '1fr' : '1fr 1fr',
                gap: Utils.isMobile() ? 40 : 80,
                alignItems: 'center',
            }}>
                {reversed && !Utils.isMobile() ? (
                    <>
                        {imageSection}
                        {contentSection}
                    </>
                ) : (
                    <>
                        {contentSection}
                        {imageSection}
                    </>
                )}
            </div>
        </section>
    );
};

export default FeaturedProduct;
